import React from 'react';
import { Box, Typography } from '@mui/material';
import { TypographyH3Bold } from '../../malnutritionScreening/style';

export const BlueHeaderWithText = ({
  text1,
  value1,
  text2,
  value2,
  single,
  customWidth,
  customMarginBottom,
  backgroundColor
}: {
  text1: any;
  value1: string;
  text2?: string;
  value2?: string;
  single: boolean;
  customWidth?: string;
  customMarginBottom?: string;
  backgroundColor?: string;
}) => {
  return (
    <Box
      sx={{
        backgroundColor: backgroundColor ? backgroundColor : '#004F71', // Blue background color
        padding: '1.5625rem 0',
        width: '100%', // Adjust width as needed
        margin: '0 auto', // Center horizontally
        textAlign: 'center',
        height: 'auto',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column'
      }}
    >
      <Box
        sx={{
          backgroundColor: '#fff', // White box background
          borderRadius: '0.625rem', // Rounded corners
          padding: '0.3125rem 0px',
          display: 'flex',
          justifyContent: 'space-between', // Space between the two texts
          alignItems: 'center',
          height: '54px',
          width: customWidth ? customWidth : '100%',
          marginBottom: customMarginBottom ? customMarginBottom : '0px'
        }}
      >
        <TypographyH3Bold sx={{ paddingLeft: '0.625rem' }}>
          <span dangerouslySetInnerHTML={{ __html: text1 }}></span>
        </TypographyH3Bold>
        <Typography
          sx={{
            color: '#007ACC', // Blue text color
            fontWeight: '700',
            fontSize: '1.875rem',
            fontFamily: 'Calibri',
            paddingRight: '0.625rem'
          }}
        >
          {value1}
        </Typography>
      </Box>
      {!single && (
        <Box
          sx={{
            backgroundColor: '#fff', // White box background
            borderRadius: '0.625rem', // Rounded corners
            padding: '0.5rem 0px',
            display: 'flex',
            justifyContent: 'space-between', // Space between the two texts
            alignItems: 'center',
            height: '54px',
            width: customWidth ? customWidth : '100%',
            marginTop: '1.25rem'
          }}
        >
          <TypographyH3Bold sx={{ paddingLeft: '0.625rem' }}>
            {text2}
          </TypographyH3Bold>
          <Typography
            sx={{
              color: '#007ACC', // Blue text color
              fontWeight: '700',
              fontSize: '1.875rem',
              fontFamily: 'Calibri',
              paddingRight: '0.625rem'
            }}
          >
            {value2}
          </Typography>
        </Box>
      )}
    </Box>
  );
};
